declare global {
  interface Array<T> {
    /**
     *
     * @param size: number
     * @returns reduce
     */
    reduce(size: number): string;
    /**
     *
     * @returns sum: string
     */
    sum(): number;
    /**
     *
     * @param value: string
     * @returns true if contains
     */
    contains(value: string): boolean;
  }
}

export class ArrayAugmentation {
  static init() {
    Array.prototype.reduce = function (fun /*, inicial*/) {
      const longitud = this.length;
      let rv: any;
      if (typeof fun !== 'function') {
        throw new TypeError();
      }

      // no se devuelve ningún valor si no hay valor inicial y el array está vacío
      if (longitud === 0 && arguments.length === 1) {
        throw new TypeError();
      }

      let indice = 0;
      if (arguments.length >= 2) {
        rv = arguments[1];
      } else {
        do {
          if (indice in this) {
            rv = this[indice++];
            break;
          }

          // si el array no contiene valores, no existe valor inicial a devolver
          if (++indice >= longitud) {
            throw new TypeError();
          }
        } while (true);
      }

      for (; indice < longitud; indice++) {
        if (indice in this) {
          rv = fun.call(null, rv, this[indice], indice, this);
        }
      }

      return rv;
    };

    Array.prototype.sum = function () {
      return this.reduce(function (total, num) {
        return total + num;
      });
    };

    Array.prototype.contains = function (value: string) {
      let i = this.length;
      while (i--) {
        if (this[i] === value) {
          return true;
        }
      }
      return false;
    }
  };
}
